import { Link } from "react-router";
import { GameVer, tturl, useRealm, useT, useTurl } from "~/util/Lang";
import { Icon } from "../ui/Icon";
import { EntityTooltip } from "../site/Tooltip";

export type SkillLinkData = {
  id: number;
  cardName: string;
  level: number | null;
  name: string;
  icon: string;
  gver?: GameVer;
};

export type CardLinkData = {
  cardName: string;
};

export function getSkillPath(props: { skill: SkillLinkData }) {
  const skill = props.skill;
  const realm = useRealm();

  return tturl(
    { lang: realm.lang, game: skill.gver ?? realm.game },
    `/skills/${skill.cardName}:${skill.level ?? 1}`,
  );
}

export function SkillLink(props: {
  data: SkillLinkData;
  iconSize?: 16 | 24;
  showIcon?: boolean;
  isLink?: boolean;
}) {
  const turl = useTurl();
  const data = props.data;
  const iconSize = props.iconSize ?? 16;
  const showIcon = props.showIcon ?? true;
  const isLink = props.isLink ?? true;
  const gap = iconSize === 16 ? 3 : 9;

  const linkContent = (
    <>
      {showIcon && (
        <span
          style={{
            display: "inline-block",
            verticalAlign: "middle",
            marginRight: gap,
          }}
        >
          <Icon
            icon={data.icon}
            size={iconSize}
            alt={`Icon Skill ${data.name}`}
            game={data.gver}
          />
        </span>
      )}
      <span>{data.name}</span>
    </>
  );

  return (
    <EntityTooltip what={{ t: "skill", uname: `${data.id}_${data.level}` }}>
      {({ setReference, getReferenceProps }) =>
        isLink ? (
          <Link
            ref={setReference}
            to={getSkillPath({ skill: data })}
            {...getReferenceProps({
              style: {
                color: "#51a0ef",
                textDecoration: "none",
              },
            })}
          >
            {linkContent}
          </Link>
        ) : (
          <span
            ref={setReference}
            {...getReferenceProps({
              style: {
                color: "#51a0ef",
                textDecoration: "none",
              },
            })}
          >
            {linkContent}
          </span>
        )
      }
    </EntityTooltip>
  );
}
